import * as React from 'react';
import { Link } from '../Link';
import * as Colors from '../../consts/variables';
import { INavigationItem } from '../../interfaces/IHeader';
import { SubNavigationMenu } from './SubNavigationMenu';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { TrackComponent } from '../TrackComponent';
import { trackingMapper } from '../../middleware/trackingHelpers';

const styleMenuLink: any = {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 5%',
    paddingRight: '27px',
};

const styleTitle: any = {
    fontSize: '17px',
};

interface Props {
    item: INavigationItem;
    iconClass?: any;
    itemStyle?: any;
    isTopNavigation?: boolean;
    children?: React.ReactElement<any>;
}

interface State {
    isOpen: boolean;
    subMenuHeight: string;
}

export class MainNavigationItem extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            subMenuHeight: 'auto',
        };
    }

    subMenuRef = null;
    getSubMenuRef = ref => (this.subMenuRef = ref);

    toggleSubMenu = ev => {
        ev.stopPropagation();
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };
    componentDidMount() {
        this.setState({
            subMenuHeight: this.subMenuRef ? this.subMenuRef.clientHeight : 'none',
        });
    }

    render() {
        const styleMenuItem: any = {
            position: 'relative',
            borderBottom: this.props.isTopNavigation
                ? this.state.isOpen
                    ? '0'
                    : `1px solid ${Colors.darkGray}`
                : '0',
            fontWeight: this.props.isTopNavigation ? 'bold' : 'normal',
            visibility: this.state.subMenuHeight === 'auto' ? 'hidden' : 'visible',
        };

        const styleSubNavWrapper: any = {
            transition: 'max-height 0.3s ease-in-out',
            overflow: 'hidden',
            maxHeight:
                this.state.subMenuHeight === 'auto'
                    ? 'none'
                    : this.state.isOpen
                    ? this.state.subMenuHeight
                    : '0',
        };

        const styleArrow: any = {
            position: 'absolute',
            right: 10,
            top: 19,
            transition: 'transform 0.3s ease-in-out',
            transformOrigin: 'center center',
            fill: this.props.isTopNavigation ? Colors.darkGray : Colors.darkAcqa,
            transform: this.state.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        };

        const hasChildren = this.props.item.children && this.props.item.children.length > 0;
        const TrackableLink = TrackComponent(Link, {
            category: this.props.isTopNavigation
                ? 'mobile-navigation-burger'
                : 'mobile-navigation-frontpage',
            action: trackingMapper[this.props.item.title],
        });

        const menuLinkStyles: any = hasChildren
            ? styleMenuLink
            : {
                  ...styleMenuLink,
                  paddingRight: 5,
              };
        return (
            <li style={{ ...styleMenuItem, ...this.props.itemStyle }}>
                {hasChildren ? (
                    <div style={menuLinkStyles} onClick={this.toggleSubMenu}>
                        {this.props.children}
                        <span
                            style={styleTitle}
                            dangerouslySetInnerHTML={{ __html: this.props.item.title }}
                        />
                        <ArrowDownIcon style={styleArrow} width={16} height={16} />
                    </div>
                ) : (
                    <TrackableLink href={this.props.item.targetUrl} style={menuLinkStyles}>
                        {this.props.children}
                        <span style={styleTitle}>{this.props.item.title}</span>
                    </TrackableLink>
                )}
                {hasChildren && (
                    <div ref={this.getSubMenuRef} style={styleSubNavWrapper}>
                        <SubNavigationMenu
                            subNavigation={this.props.item.children}
                            isTopNavigation={this.props.isTopNavigation}
                            parentTitle={this.props.item.title}
                        />
                    </div>
                )}
            </li>
        );
    }
}
